export default __webpack_public_path__ + "a47a09a1da62a06a397accb00533767c.jpg";